import { Route, Routes, ScrollRestoration } from "react-router-dom";
import SelectTransferType from "./payments/send/SelectTransferType";
import SendContextProvider from "../context/SendContext";
import SearchUser from "./payments/send/visaro/SearchUser";
import Amount from "./payments/send/Amount";
import AccountDetails from "./payments/send/bank/AccountDetails";

const Send = () => {
  return (
    <SendContextProvider>
      <ScrollRestoration />
      <Routes>
        <Route path="/" element={<SelectTransferType />} />
        <Route path="/visaro" element={<SearchUser />} />
        <Route path="/visaro/amount" element={<Amount />} />
        <Route path="/bank" element={<AccountDetails />} />
        <Route path="/bank/amount" element={<Amount />} />
      </Routes>
    </SendContextProvider>
  );
};

export default Send;
